import { Doc } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postDownloadApplicationDocs = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<Doc[]> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/docs/download`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.RelatedDefinitionName]: 'doc',
      },
    },
    { preventDefaultErrorToast: true },
  );
